import { useState } from "react";
import axiosInstance from "../../utils/axiosConfig";
import { toast } from "react-toastify";

const useAuthAdmin = () => {
  const isJwtExpired = (token) => {
    if (!token || typeof token !== "string") return true;
    try {
      const parts = token.split(".");
      if (parts.length !== 3) return true;
      const payload = JSON.parse(atob(parts[1]));
      const exp = payload?.exp;
      if (!exp) return true;
      const nowInSeconds = Math.floor(Date.now() / 1000);
      return nowInSeconds >= exp;
    } catch {
      return true;
    }
  };

  const [adminSession, setAdminSession] = useState(() => {
    const savedSessionRaw = localStorage.getItem("adminSession");
    const savedSession = savedSessionRaw ? JSON.parse(savedSessionRaw) : null;
    if (savedSession && isJwtExpired(savedSession)) {
      localStorage.removeItem("adminSession");
      localStorage.removeItem("userRole");
      localStorage.removeItem("id");
      return null;
    }
    return savedSession;
  });

  const saveAdminSession = (session) => {
    localStorage.setItem("adminSession", JSON.stringify(session));
    setAdminSession(session);
  };

  const removeAdminSession = () => {
    localStorage.removeItem("adminSession");
    localStorage.removeItem("userRole")
    setAdminSession(null);
  };

  const checkAdminSession = () => {
    if (adminSession) {
      return true;
    } else {
      return false;
    }
  };

  const login = async (email, password) => {
    try {
      const response = await axiosInstance.post(
        `/api/auth/login-admin`,
        {
          email,
          password,
        }
      );
  
      if (response.data.status === "200") {
        const userRole = response.data.data.role;
        const id = response.data.data.id;
        const successMessage =
          userRole === "ROLE_ADMIN"
            ? "Successfully logged in as Admin!"
            : "Successfully logged in as SubContractor!";
            
        toast.success(successMessage, {
          toastId: userRole === "ROLE_ADMIN" ? "adminLogin" : "subContractorLogin",
        });
        
        localStorage.setItem("userRole", userRole);
        localStorage.setItem("id", id);
        saveAdminSession(response.data.data.accessToken);
        localStorage.setItem("adminSessionStartedAt", String(Date.now()));
        return { userRole, id };
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        toast.error("Unauthorized: Invalid username or password");
      } else {
        toast.error(
          "Login failed: " + (error.response?.data?.message || error.message)
        );
      }
      throw error; // Rethrow to let the caller handle it
    }
  };

  const logout = (navigateTo) => {
    removeAdminSession();
    localStorage.removeItem("adminSessionStartedAt");

    navigateTo();
  };

  return {
    adminSession,
    saveAdminSession,
    removeAdminSession,
    login,
    checkAdminSession,
    logout,
  };
};

export default useAuthAdmin;
